"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const messages_1 = __importDefault(require("../../lib/messages"));
function default_1(intl) {
    return {
        addOns: {
            'consent-add-on': [
                {
                    sentence: intl.formatMessage(messages_1.default.confirmText)
                },
                {
                    hasModal: true,
                    modalContent: {
                        body: intl.formatMessage(messages_1.default.confirmModalContent),
                        title: intl.formatMessage(messages_1.default.confirmModalTitle)
                    },
                    sentence: intl.formatMessage(messages_1.default.learnMoreLink)
                }
            ]
        },
        fields: [
            {
                label: intl.formatMessage(messages_1.default.cancelationReasonNotesTitle),
                path: 'apptCancel.notes',
                rows: 5,
                type: 'textarea',
                maxLength: 500,
                displayCharacterCount: true
            }
        ]
    };
}
exports.default = default_1;
//# sourceMappingURL=formConfig.js.map